import {ChangeDetectorRef, Injectable} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ReplaySubject} from 'rxjs';
import {SnackBarDataModel} from '../models/snack-bar-model'

@Injectable()
export class FreshPassModalService {
    bsModalRef: BsModalRef;
    changeDetectorRef: ChangeDetectorRef;

    private $snackBar = new ReplaySubject<SnackBarDataModel>(1);
    public snackBar = this.$snackBar.asObservable();

    constructor(private modalService: BsModalService) {
    }

    openModalWithComponent(modalComponent: any, config: any) {
        this.bsModalRef = this.modalService.show(modalComponent, Object.assign({backdrop: 'static'}, config));
        return this.bsModalRef;
    }

    public setSnackBar = (data: SnackBarDataModel) => {
        this.$snackBar.next(data);
    }
}
